/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import { gql, useQuery } from '@apollo/client';

export const FETCH_REFINITIVE_DATA_GQL = gql`
query RefinitiveDetails($spotPriceTime: String) {
  refinitiveDetails(spotPriceTime: $spotPriceTime) {
    metalsSpotPriceByTimeStamp {
      metalSpotPrices {
        cadPrice
        usdPrice
        usdToCad
        partnumber
        startDate
      }
    }
    metalsSpotPriceFromOffer {
      metalSpotPrices {
        cadPrice
        usdPrice
        usdToCad
        partnumber
        startDate
      }
    }
  }
}
`;

/** Returns yesterday's 5:00 PM EST as "YYYY-MM-DD 17:00:00" */
const getPreviousDayFivePmEst = (): string => {
  const now = new Date();
  // Resolve current date in America/Toronto wall-clock, then step back one day
  const estNow = new Date(now.toLocaleString('en-US', { timeZone: 'America/Toronto' }));
  const prev = new Date(estNow);
  prev.setDate(prev.getDate() - 1);
  prev.setHours(17, 0, 0, 0);
  const pad = (n: number) => String(n).padStart(2, '0');
  return (
    `${prev.getFullYear()}-${pad(prev.getMonth() + 1)}-${pad(prev.getDate())} ` +
    `${pad(prev.getHours())}:${pad(prev.getMinutes())}:${pad(prev.getSeconds())}`
  );
};

export const useFetchRefinitiveData = (options?: { skip?: boolean }) => {
  const spotPriceTime = getPreviousDayFivePmEst();

  const { data, loading, error } = useQuery(FETCH_REFINITIVE_DATA_GQL, {
    fetchPolicy: 'network-only',
    skip: options?.skip ?? false,
    variables: { spotPriceTime },
    context: {clientName: 'refinitiv'}
  });

  return { data, loading, error };
};
